<template>
  <nav
    id="navbarBlur"
    :class="`${
      !isNavFixed
        ? 'navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none'
        : `navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none position-sticky ${
            darkMode ? 'bg-default' : 'bg-white'
          } left-auto top-2 z-index-sticky`
    } ${isRTL ? 'top-0 position-sticky z-index-sticky' : ''}`"
    v-bind="$attrs"
    data-scroll="true"
  >
    <div class="px-0 py-1 container-fluid">
      <breadcrumbs
        :current-page="currentRouteName"
        :current-directory="currentDirectory"
      />
      <div
        class="pe-md-3 d-flex align-items-center"
        :class="isRTL ? 'me-md-auto' : 'ms-md-auto'"
      >
        <div v-if="false" title="Resize" class="d-flex align-items-center" @click="setSideNavVisibility(!showSidenav)">
          <IconResize></IconResize>
        </div>
        <div
          id="navbar"
          class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
          :class="isRTL ? 'px-0' : 'me-sm-4'"
        >
          <ul v-if="loggedInUser" class="navbar-nav justify-content-end">
            <li class="nav-item d-flex align-items-center">
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div class="row d-flex align-items-center">
                    <div class="col text-end text-xxs m-0 p-0 text-uppercase">
                      <div class="text-info">
                        {{ loggedInUser.role ? loggedInUser.role.name : "" }}
                      </div>
                      <div>{{ loggedInUser.name }}</div>
                    </div>
                    <div class="col-auto ps-2 pe-0">
                      <div class="photo">
                        <img
                          alt="Profile photo"
                          class="avatar rounded-circle"
                          :src="commander"
                        />
                      </div>
                    </div>
                    <div class="col-auto my-auto">
                      <i class="fa fa-caret-down"></i>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a class="dropdown-item" href="#" @click="logout()"
                      >Log out</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <div
          class="sidenav-toggler sidenav-toggler-inner d-block"
          :class="isRTL ? 'me-3' : ''"
        >
          <a
            href="#"
            class="p-0 nav-link text-body"
            @click.prevent="navbarMinimize"
          >
            <div class="sidenav-toggler-inner">
              <i
                class="sidenav-toggler-line"
                :class="
                  isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-white'
                "
              ></i>
              <i
                class="sidenav-toggler-line"
                :class="
                  isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-white'
                "
              ></i>
              <i
                class="sidenav-toggler-line"
                :class="
                  isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-white'
                "
              ></i>
            </div>
          </a>
        </div>

      </div>
    </div>
  </nav>
</template>
<script>
import commander from "@/assets/img/persons/avatar.png";
import IconResize from "@/shared/Controls/Icons/IconResize.vue";
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Navbar",
  components: {
    Breadcrumbs,
    IconResize,
  },
  data() {
    return {
      showMenu: false,
      commander,
      loggedInUser: null,
    };
  },
  computed: {
    ...mapState(["isRTL", "isNavFixed", "darkMode", "showSidenav"]),
    currentRouteName() {
      return this.$route.name;
    },
    currentDirectory() {
      let dir = this.$route.path.split("/")[1];
      return dir.charAt(0).toUpperCase() + dir.slice(1);
    },
  },
  created() {
    this.minNav;
  },
  beforeUpdate() {
    this.toggleNavigationOnMobile();
  },
  mounted() {
    this.loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator", "setSideNavVisibility"]),
    ...mapActions(["toggleSidebarColor"]),
    toggleNavigationOnMobile() {
      if (window.innerWidth < 1200) {
        this.navbarMinimize();
      }
    },
    logout() {
      this.$store.dispatch("auth/signOut").finally(() => {
        this.$router.push({ name: "Login", replace: true });
      });
    },
  },
};
</script>

<style scoped>
.btn-secondary {
  background: none;
  margin: 0;
}

.avatar {
  height: 36px;
  width: 36px;
}

.dropdown > .dropdown-toggle {
  background: none;
}

.dropdown-toggle::after {
  display: none;
}
</style>
